import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getPageSettings } from "../services/pagesettingServices.ts";

const ensureMeta = (name) => {
  let tag = document.querySelector(`meta[name="${name}"]`);

  // 1. Define the reference point (the very start of the <head>)
  const firstHeadChild = document.head.firstChild;

  if (!tag) {
    // 2a. Tag does NOT exist: Create it and insert it at the beginning.
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    tag.setAttribute("data-meta-key", name); // Optional: A custom attribute for easier debugging/identification

    document.head.insertBefore(tag, firstHeadChild);
  } else {
    // 2b. Tag DOES exist: Move the existing tag to the beginning.
    // insertBefore(elementToMove, referenceElement)
    // If elementToMove is already in the DOM, insertBefore will move it.

    // We only need to move it if it's not already the first child
    if (tag !== firstHeadChild) {
      document.head.insertBefore(tag, firstHeadChild);
    }
  }

  return tag;
};

export default function usePageMeta(pageKey) {
  const { language } = useLanguage();

  useEffect(() => {
    let active = true;
    const apply = async () => {
      try {
        const data = await getPageSettings({
          page: "clientpagesseo",
          lang: language,
        });
        const langKey = language === "ar" ? "ar" : "en";
        const section = data?.[pageKey]?.[langKey] || data?.[pageKey] || [];
        const meta = Array.isArray(section) ? section[0] : section?.[0];
        const title = meta?.meta_title?.value || "KhatAlJazeera Auction";
        const description = meta?.meta_description?.value || "";
        const keywords = meta?.meta_keywords?.value || "";

        if (!active) return;
        document.title = title;
        ensureMeta("keywords").setAttribute("content", keywords);
        ensureMeta("description").setAttribute("content", description);
        ensureMeta("title").setAttribute("content", title);
      } catch (e) {
        // silent fail
      }
    };
    apply();
    return () => {
      active = false;
    };
  }, [pageKey, language]);
}
